export default "/assets/images/mila-air-3-alt.fe96a4c85707ac22.jpg";